export default "__VITE_ASSET__DY_82ock__"